
//Express support 
// export const GetFaqs = 'Faqs/GetFaqs'
// export const  GetAnswerByArtCatId = 'Faqs/GetAnswerByArtCatId'
// export const  GetHelpDetailsByPageId = 'Faqs/GetHelpDetailsByPageId'


//SpanSupport - AIChatBot Controller
export const GetAIChatBotDetailsById = 'AIChatBot/GetAIChatBotDetails'
export const SaveChatConversations = 'AIChatBot/SaveChatConversation'
export const GetAllConversation = 'AIChatBot/GetAllConversationByEmail'
export const GetConversationBySession = 'AIChatBot/GetConversationBySession'
export const UpdateMessageCommand = 'AIChatBot/UpdateMessageCommands'
export const AIChatLogin = 'Auth/AIChatLogin'
export const ToggleLiveChatStatus = 'AIChatBot/ToggleLiveChatStatus'
export const ConvertExcelToCSV = "AIChatBot/ConvertExcelToCSV/"
export const GetSummaryPdf = "AIChatBot/GenerateSummaryPdf"
export const GetUserIdFromJWT = "AIChatBot/GetUserIdFromJWT"
export const ExtractDocument = "AIChatBot/ExtractDocument/"
export const UpdateActiveAI = "AIChatBot/UpdateActiveAI"
export const SendMessageToLiveAgent = "AIChatBot/SendMessageToLiveAgent"
export const CreateContact = "AIChatBot/CreateContact"
export const CreateConversation = "AIChatBot/CreateConversation"
export const GetAnswerByArtCatId = "AIChatBot/GetAnswerByArtCatId"
export const GetFaqs = 'AIChatBot/GetFaqs'
export const AddLabels = 'AIChatBot/AddLabels'


//Chatwoot 

export const Agents = "agents"

//AI Api
export const ExcelToCSV = "v1.1/exceltocsv/"